import { z } from 'zod';

const mtrSpecOptionSchema = z.object({
  id: z.string().optional(),
  code: z.string().trim().min(1, '選項代號不能為空').max(50, '選項代號最多 50 字'),
  name: z.string().trim().min(1, '選項名稱不能為空').max(100, '選項名稱最多 100 字'),
});

export const mtrSpecFormSchema = z.object({
  code: z.string().trim().min(1, '代號不能為空').max(50, '代號最多 50 字'),
  name: z.string().trim().min(1, '名稱不能為空').max(100, '名稱最多 100 字'),
  remark: z.string().max(500, '備註最多 500 字').optional().or(z.literal('')),
  specType: z.enum(['SELECT', 'INPUT']),
  options: z.array(mtrSpecOptionSchema),
}).superRefine((data, ctx) => {
  if (data.specType !== 'SELECT') {
    return;
  }

  if (data.options.length === 0) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: '固定項目至少需要一個選項',
      path: ['options'],
    });
  }
});

export const MTR_SPEC_TYPE_OPTIONS = [
  { value: 'SELECT', label: '固定項目（SELECT）' },
  { value: 'INPUT', label: '輸入項目（INPUT）' },
];
